var React = require('react');

function Lambda (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M194.62 243.73l-95 221.72A24 24 0 0 1 77.54 480H25.31a24 24 0 0 1-22.06-33.45l132.88-310.06z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M448 408v48a24 24 0 0 1-24 24h-81.5a32 32 0 0 1-28.1-16.68L131.5 128H24a24 24 0 0 1-24-24V56a24 24 0 0 1 24-24h145.5a32 32 0 0 1 28.1 16.68L380.5 384H424a24 24 0 0 1 24 24z","className":"fa-primary","key":2})]);
}

Lambda.defaultProps = {"viewBox":"0 0 448 512","className":"icon"};

module.exports = Lambda;

Lambda.default = Lambda;
